import { Component, OnInit, ElementRef, ViewChild, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { Testigo } from '../model/testigo';
import { Medida } from '../model/medida';
import { Documento } from '../model/documento';
import { DatePipe } from '@angular/common'
import { Comentario } from '../model/comentario';
import { FormControl, FormGroup } from "@angular/forms";
import { environment } from "../../environments/environment.prod"
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas'
import { Acciones } from '../model/acciones';
import { Rol } from '../model/rol';
import { SpinnerService } from '../services/spinner.service';
import { PeertopeerService } from '../shared/services/peertopeer.service';
import { Parametros } from '../model/parametros';
import { ConfiguracionAvanzadaService } from '../dashboard/services/configuracion-avanzada.service';
import { Apelaciones } from '../model/datosApelaciones';
import { EnviarCorreoTestigoComponent } from '../enviar-correo-testigo/enviar-correo-testigo.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Response } from '../shared/models/response.model';
import { DatosApelacion } from '../model/datosApelacion';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FileUtilsService } from '../shared/services/file-utils.service';

declare var require: any
const FileSaver = require('file-saver');
@Injectable()
@Component({
  selector: 'app-editar-todas-denuncias',
  templateUrl: './editar-todas-denuncias.component.html',
  styleUrls: ['./editar-todas-denuncias.component.css'],
  providers: [DatePipe]
})
export class EditarTodasDenunciasComponent implements OnInit {
  assetsUrl: string = environment.baseAssetsUrl;
  validatingForm: FormGroup;
  isFinished: boolean = false;
  pin_code: string;
  denuncia: DatosDenuncia[];
  apelaciones: Apelaciones;
  apelacionActual?: DatosApelacion;
  testigo: Testigo[];
  medida: Medida[];
  documento: Documento[];
  accion: Acciones[];
  bExisteAccion: boolean = false;
  bExisteTestigo = true;
  bExisteMedida = true;
  bExisteDocumento = true;
  id: string;
  comentarios: Comentario[];
  avatar: string;
  showChat: boolean = false;
  sendChat: boolean = false;
  isReceptor: boolean = false;
  isFaseExterno: boolean = false;
  isDecisor: boolean = false;
  isInvestigador: boolean = false;
  isCompliance: boolean = false;  // variable to identify when is compliance role.
  isFaseInicial: boolean = false;
  isFaseDecisor: boolean = false;
  isFaseCompliance: boolean = false;
  progressBar: number = 0;
  isFaseInvestigador = false;
  backgroundColor: string = 'red';
  showDocument: boolean = false;
  showButtonArchive: boolean = false; //show button archive complaint
  @ViewChild('content') content: ElementRef;
  showBotonera = false;
  idrole: string;
  showExport = false;
  archivo: Documento[];
  isActiveCenter: string; //Variable para guardar el valor del centro: TRUE OR FALSE
  showCenter: boolean = false; //variable para mostrar el campo centro en el HTML con valor TRUE OR FALSE
  roles: Rol[];
  showButtonChangeTypeComplaint: boolean = false; //button that show selected type complaint
  showButtonChangePhase: boolean = false; //button that show selected changed phase
  showCommentaryPhase: string; //show commentary from phase changed
  showDivFromCommentary: boolean = false; //show DIV where it show commentary
  consultaResultados: any; //Show Investigators from complaints
  isActiveIdPersonalizable: boolean = false; //Is Active Id Custom
  parametros: Parametros;
  linkDrive: string; //Cloud Storage Url
  showLinkDrive: boolean = false;
  isActiveDrive: boolean = false; //Is Active Cloud Storage
  // To know if the current user is intervening
  currentUserId: string;
  isIntervening: boolean = false;
  isActiveFaseAppeals: boolean = false;
  isLoading: boolean = false;
  url: SafeResourceUrl | null = null;
  showFile = false;
  mimeType: string | null = null;
  showPreviewInfo = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private actRoute: ActivatedRoute,
    private datepipe: DatePipe,
    private cryptoService: PeertopeerService,
    private spinnerSvc: SpinnerService,
    private configuracionAvanzadaService: ConfiguracionAvanzadaService,
    private modalService: NgbModal,
    private fileUtilsService: FileUtilsService

  ) { }

  ngOnInit() {
    // Initialize language, route id and form
    const language = this.setupLanguageAndForm();

    // Retrieve current user and center settings
    const isActiveCenter = this.setupUserAndCenter();

    // Load advanced configuration (drive params)
    this.loadAdvancedConfig();

    // Initial avatar and complaints lookups
    this.avatar = environment.baseAvatar + 'social.png';
    this.translate.setDefaultLang(language);
    // this.loadComplaintByIdUser(language, isActiveCenter);
    this.loadComplaintById(language, isActiveCenter);
  }

  private setupLanguageAndForm(): string {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }

    this.id = this.actRoute.snapshot.params.id;
    this.validatingForm = new FormGroup({ comentarioDenuncia: new FormControl('') });

    // Retrieve the current user's ID
    this.currentUserId = localStorage.getItem('id_user_session') || '';

    // check if idPersonalizado is active
    if (this.auth.getIdPersonalizable() == '1') {
      this.isActiveIdPersonalizable = true;
    }

    return language;
  }

  private setupUserAndCenter(): string {
    let isActiveCenter = '0';
    if (this.auth.getCentros() == '1') {
      isActiveCenter = '1';
      this.showCenter = true;
    }
    return isActiveCenter;
  }

  private loadAdvancedConfig(): void {
    this.configuracionAvanzadaService.searchAdvancedParam(this.auth.getSociedad()).subscribe({
      next: (response) => {
        if (response.success && response.data && response.code === 200) {
          this.parametros = response.data;
          this.linkDrive = this.parametros[79]?.valor ?? '';
          this.isActiveDrive = this.parametros[80]?.valor === '1';
        } else if (response.code === 404 && !response.success) {
          this.toastr.error(this.translate.instant('texto_899'));
          this.linkDrive = '';
          this.isActiveDrive = false;
        }
      },
      error: (err) => {
        this.toastr.error(this.translate.instant('texto_813'), this.translate.instant('texto_890'));
        this.linkDrive = '';
        this.isActiveDrive = false;
      }
    });
  }

  // private loadComplaintByIdUser(language: string, isActiveCenter: string): void {
  //   this.apiService.searchComplaintByIdUser(this.auth.getSociedad(), this.id, this.auth.getIdUser(), language, isActiveCenter, this.isActiveIdPersonalizable).subscribe({
  //     next: (denuncia) => {
  //       if (denuncia.code === 200 && denuncia.success) {
  //         this.denuncia = denuncia.data;
  //         if (denuncia.data.length != 0) {
  //           this.showBotonera = true;
  //         }
  //       }
  //     },
  //     error: (err) => {
  //       this.denuncia = [];
  //     }
  //   });
  // }

  private loadComplaintById(language: string, isActiveCenter: string): void {
    this.isLoading = true;
    this.apiService.searchComplaintById(this.id, language, this.auth.getIdUser(), isActiveCenter, this.isActiveIdPersonalizable, 'gestor').subscribe({
      next: (denuncia) => {
        if (denuncia.code === 200 && denuncia.success) {
          this.denuncia = denuncia.data;
          if (this.denuncia.length == 0) {
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['dashboard/complaint-management/mis-denuncias']);
            });
          } else {
            this.showBotonera = true;
            this.processComplaintData(language);
          }
          // common calls after complaint loaded
          this.apiService.searchCommentsByComplaint(this.id, false, 'gestor').subscribe({
            next: (response: Response<Comentario[]>) => {
              if (response.code === 200 && response.success) {
                this.comentarios = response.data || [];
                this.showChat = this.comentarios.length > 0;
              } else {
                this.comentarios = [];
                this.showChat = false;
              }
            }, error: (err) => {
              this.comentarios = [];
              this.showChat = false;
            }
          });

          this.apiService.showCommentaryPhaseChange(this.id, this.auth.getSociedad(), this.denuncia[0].id_fase).subscribe((res => {
            this.showCommentaryPhase = res;
            if (this.showCommentaryPhase != '' && this.showCommentaryPhase != null) {
              this.showDivFromCommentary = true;
            }
          }));
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(this.translate.instant('texto_904'), this.translate.instant('texto_813'));
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => this.router.navigate(['dashboard/complaint-management/todas-denuncias']));
        return;
      }
    });
  }

  private processComplaintData(language: string): void {
    // Determine roles and phase-specific flags
    let role = '';
    this.apiService.searchRoleByUserSociety('setUser', this.auth.getSociedad(), '1').subscribe({
      next: (roles) => {
        if (roles.success && roles.code === 200) {
          this.roles = roles.data;
          for (let i = 0; i < this.roles.length; i++) {
            role = role + ',' + this.roles[i].id_rol;
          }
          this.idrole = '0';
          const fase = this.denuncia[0].id_fase;
          if (fase == '0') {
            this.progressBar = 10;
            this.showChat = true;
            this.sendChat = true;
            if (role.includes('1')) {
              this.isFaseInicial = true;
              this.idrole = '1';
              this.showButtonChangeTypeComplaint = true;
            }
          } else if (fase == '11') {
            this.progressBar = 10;
            this.showChat = true;
            this.sendChat = true;
            if (role.includes('11')) {
              this.isFaseExterno = true;
              this.idrole = '11';
              this.isFaseInicial = false;
              this.showButtonChangeTypeComplaint = true;
            }
          } else if (fase == '1') {
            this.progressBar = 25;
            this.showChat = true;
            this.backgroundColor = 'red';
            this.sendChat = true;
            this.isFaseInvestigador = true;
            this.showButtonChangePhase = true;
          } else if (fase == '2') {
            this.showChat = true;
            this.progressBar = 50;
            this.isFaseInvestigador = false;
            this.showButtonChangePhase = true;
            if (role.includes('2')) {
              this.isInvestigador = true;
              this.showDocument = true;
              if (this.isActiveDrive) {
                this.showLinkDrive = true;
              }
            }
            if (role.includes('4')) {
              this.isCompliance = true;
            }
            this.backgroundColor = '#F1C453';
            this.sendChat = true;
          } else if (fase == '3') {
            this.progressBar = 65;
            this.showButtonChangePhase = true;
            if (role.includes('1')) {
              this.isFaseDecisor = true;
            } else {
              this.isFaseDecisor = false;
            }
            this.isFaseInvestigador = false;
            this.isFaseInicial = false;
            this.backgroundColor = '#EFEA5A';
            this.sendChat = true;
          } else if (fase == '4') {
            if (role.includes('3')) {
              this.isDecisor = true;
              this.isFaseDecisor = true;
              if (this.isActiveDrive) {
                this.showLinkDrive = true;
              }
            }
            if (role.includes('4')) {
              this.isCompliance = true;
            }
            this.progressBar = 75;
            this.backgroundColor = '#B9E769';
            this.showDocument = true;
            this.sendChat = false;
            this.isFaseDecisor = false;
            this.showButtonChangePhase = true;
          } else if (fase == '5') {
            this.isFaseDecisor = false;
            this.isFaseCompliance = true;
            this.progressBar = 85;
            this.backgroundColor = '#83E377';
            this.showButtonChangePhase = true;
            if (role.includes('4') && this.isActiveDrive) {
              this.showLinkDrive = true;
            }
          } else if (['6', '7', '8'].includes(fase)) {
            this.progressBar = 100;
            this.backgroundColor = '#16DB93';
            this.isFinished = true;
          } else if (fase == '12') {
            this.backgroundColor = '#a6a5a5';
            this.progressBar = 100;
            this.isFaseInvestigador = false;
            this.showChat = true;
            this.sendChat = true;
            this.isActiveFaseAppeals = true;
          }

          if (this.showBotonera == false) {
            if (role.includes('4')) {
              this.showExport = true;
            }
          } else {
            this.showExport = true;
          }

          // subsequent API calls dependent on idrole / flags
          this.apiService.searchWitnessByComplaint(this.id, this.idrole).subscribe({
            next: (response) => {
              if (response.code === 200 && response.success) {
                this.testigo = response.data;
                this.bExisteTestigo = response.data.length > 0;
              } else {
                this.testigo = [];
                this.bExisteTestigo = false;
              }
            }, error: (err) => {
              this.testigo = [];
              this.bExisteTestigo = false;
            }
          });

          this.apiService.searchMedidaPorIdDenuncia(this.id).subscribe({
            next: (medidas) => {
              this.medida = medidas.data;
              if (medidas.data.length == 0) {
                this.bExisteMedida = false;
              }
            }, error: (err) => {
              this.medida = [];
              this.bExisteMedida = false;
            }
          });

          this.apiService.FindUsersByReportID(this.id, this.auth.getSociedad()).subscribe((resultado: any) => {
            this.consultaResultados = resultado;
            this.isIntervening = this.consultaResultados.some(item => item.id_user === this.currentUserId);
          });

          this.apiService.searchDocumentsByComplaint(this.id, true, this.idrole).subscribe(res => {
            if (res.code === 200 && res.success) {
              this.documento = res.data;
              if (this.documento.length == 0) {
                this.bExisteDocumento = false;
              }
            } else {
              this.documento = [];
              this.bExisteDocumento = false;
            }
          }, err => {
            this.documento = [];
            this.bExisteDocumento = false;
          });

          if (this.isFaseCompliance || this.isFinished) {
            this.apiService.searchActionsByComplaint(this.id).subscribe({
              next: (response) => {
                if (response.code === 200 && response.success) {
                  this.accion = response.data || [];
                  if (response.data) {
                    this.bExisteAccion = true;
                    if (this.isFinished) {
                      this.bExisteAccion = false;
                      this.showButtonArchive = true;
                    }
                  }
                }
              },
              error: (error) => {
                if (error.error.code === 404) {
                  this.accion = [];
                  this.bExisteAccion = false;
                } else {
                  this.accion = [];
                  this.bExisteAccion = false;
                  this.toastr.error(this.translate.instant('texto_895'), this.translate.instant('texto_813'));
                }
              }
            });

            this.apiService.searchActionsByComplaint(this.id).subscribe(response => {
              if (response.code === 200 && response.success) {
                this.accion = response.data || [];
                if (response.data) {
                  this.bExisteAccion = true;
                  if (this.isFinished) {
                    this.bExisteAccion = false;
                    this.showButtonArchive = true;
                  }
                }
              } else if (response.code === 500 && !response.success) {
                this.accion = [];
                this.toastr.error(this.translate.instant('texto_895'), this.translate.instant('texto_813'));
              }
            }, error => {
              if (error.error.code !== 404 && !error.error.success) {
                this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_896'));
              }
              this.accion = [];
            });
          }
        }
      }, error: (err) => {
        this.toastr.error(this.translate.instant('texto_915'), this.translate.instant('texto_813'));
      }
    }); //End

    this.apiService.getAppealsByComplaint(this.denuncia[0].id_denuncia, 'gestor').subscribe({
      next: (response: Apelaciones) => {
        this.apelaciones = response;
      },
      error: (err) => {
        this.toastr.error(this.translate.instant('texto_850'), this.translate.instant('texto_813'));
      }
    });

    this.apiService.getCurrentAppealByComplaint(this.denuncia[0].id_denuncia).subscribe({
      next: (response: DatosApelacion) => {
        if (response.message) {
        } else {
          this.apelacionActual = response;
        }
      },
      error: (err) => {
      }
    });
  }


  get comentarioDenuncia() {
    return this.validatingForm.get('comentarioDenuncia');
  }

  enviarMensaje(id_denuncia) {
    let date = new Date();
    let _date = this.datepipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    let comentario = this.comentarioDenuncia.value.replace(/<[^>]*>/g, '');
    if (comentario != null && comentario != "") {
      comentario = comentario.replace(/'/g, '');
      //encrypt data
      const encryIdSociedad = this.cryptoService.encryptData(this.denuncia[0].id_sociedad);
      const encryIdDenuncia = this.cryptoService.encryptData(String(id_denuncia));
      const encrytNombre = this.cryptoService.encryptData('setUser');
      const encryComentario = this.cryptoService.encryptData(comentario);
      const encryDate = this.cryptoService.encryptData(_date);
      const encryIdUsuarioIdentificador = this.cryptoService.encryptData('setUser');


      this.apiService.sendMessageChat(encryIdSociedad, encryIdDenuncia, encrytNombre, encryComentario, encryDate, encryIdUsuarioIdentificador, false).subscribe(
        res => {
          if (res == 200) {
            this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_484'));
          } else {
            this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_484'));
          }
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['editar-todas-denuncias/', this.id]);
          });
        });
    } else {
      this.toastr.error(this.translate.instant('texto_481'), this.translate.instant('texto_484'));
    }
  }

  /**
   * Exports the current complaint view to a PDF document.
   * If there are attached documents, prompts the user to download them as well.
   */
  exportarDocumento() {
    let ok = false;
    if (this.documento.length > 0) {
      if (confirm(this.translate.instant('texto_941'))) {
        ok = true;
      }
    }

    // Save original styles to restore later
    const panelChat = document.querySelector('.panel-body-chat') as HTMLElement;
    const originalOverflow = panelChat.style.overflowY;
    const originalHeight = panelChat.style.height;

    panelChat.style.overflowY = 'visible';
    panelChat.style.height = 'auto';

    // Hide buttons and other elements not to be printed
    const botonera = document.getElementById('botonera');
    botonera.style.display = 'none';

    const data = document.getElementById('contenedor');

    // Generate PDF
    html2canvas(data).then(canvas => {

      let HTML_Width = canvas.width;
      let HTML_Height = canvas.height;
      let top_left_margin = 0;

      let PDF_Width = HTML_Width
      let PDF_Height = (PDF_Width * (11 / 8.5))

      let totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      let imgData = canvas.toDataURL("image/jpeg", 1.0);

      let pdf = new jspdf('p', 'pt', [PDF_Width, PDF_Height]);

      pdf.addImage(imgData, 'JPG',
        top_left_margin,
        top_left_margin,
        HTML_Width,
        HTML_Height
      );

      for (let i = 1; i <= totalPDFPages; i++) {
        pdf.addPage([PDF_Width, PDF_Height], 'p');
        pdf.addImage(
          imgData,
          'JPG',
          top_left_margin,
          -(PDF_Height * i),
          HTML_Width,
          HTML_Height
        );
      }

      let d = new Date().toISOString();
      pdf.save('report-' + d + '.pdf');

      // Download attached documents if user confirmed
      if (ok) {
        let idDenuncia = null;
        const ids = this.documento.map(doc => String(doc.id_archivo));
        if (this.isActiveIdPersonalizable) {
          idDenuncia = this.denuncia[0].identificador_denuncia ? this.denuncia[0].identificador_denuncia : this.denuncia[0].id_denuncia;
        } else {
          idDenuncia = this.denuncia[0].id_denuncia;
        }

        this.downloadDocumentsZip(ids, idDenuncia);
      }

      // Restore panel-body
      document.querySelectorAll('.panel-body').forEach((el: any) => {
        el.style.overflow = el.dataset._overflow;
        el.style.height = el.dataset._height;
      });

      document.querySelectorAll('.panel, .panel-body, .panel-heading')
        .forEach((el: any) => {
          el.style.border = el.dataset._border;
          delete el.dataset._border;
        });

      // Restore scroll
      panelChat.style.overflowY = originalOverflow;
      panelChat.style.height = originalHeight;

      document.querySelectorAll('*').forEach((el: any) => {
        if (el.dataset._overflow_force !== undefined) {
          el.style.overflow = el.dataset._overflow_force;
          delete el.dataset._overflow_force;
        }

        if (el.dataset._height_force !== undefined) {
          el.style.height = el.dataset._height_force;
          delete el.dataset._height_force;
        }
      });

      // Show buttons
      botonera.style.display = 'block';

    });
  }

  finalizarAccion(id_action: string) {
    this.apiService.updateActionsById(this.denuncia[0].id_denuncia, id_action).subscribe(
      res => {
        if (res.success && res.code === 200) {
          this.toastr.success(
            this.translate.instant('texto_283'),
            this.translate.instant('texto_285')
          );
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
          });
        }


      },
      error => {
        this.toastr.error(
          this.translate.instant('texto_284'),
          this.translate.instant('texto_813')
        );
      }
    );
  }

  /**
   * Checks if document preview is enabled in settings.
   * @returns boolean indicating if document preview is enabled.
   */
  isDocumentPreviewEnabled(): boolean {
    const documentPreview = this.auth.getDocumentPreview();
    return documentPreview === '1';
  }

  /**
   * Checks if the MIME type is previewable in the UI.
   * @param tipo_archivo The MIME type of the file.
   * @returns boolean indicating if the file type is previewable.
   */
  isVisualizable(tipo_archivo: string): boolean {
    return this.fileUtilsService.isVisualizable(tipo_archivo);
  }

  /**
   * Closes the preview information message.
   */
  closePreviewInfo(): void {
    this.showPreviewInfo = false;
  }

  /**
   * Downloads multiple documents as a ZIP file.
   */
  downloadDocumentsZip(ids: string[], id_denuncia: string) {
    this.fileUtilsService.downloadDocumentsZip(ids, id_denuncia);
  }

  /**
   * Downloads a file by its ID.
   */
  downloadFile(id_archivo: number) {
    this.fileUtilsService.downloadFile(id_archivo, 'gestor');
  }

  /**
   * Displays a supported file type in an iframe viewer.
   */
  viewFile(id_archivo: number, tipo_archivo: string, n_archivo: string) {
    this.fileUtilsService.viewFile(id_archivo, tipo_archivo, n_archivo, 'gestor', (url, mimeType) => {
      this.url = url;
      this.mimeType = mimeType;
      this.showFile = true;
    });
  }

  openLinkDrive(): void {
    window.open(this.linkDrive, '_blank');
  }

  openEnviarCorreoTestigo(testigo: Testigo) {
    const modalRef = this.modalService.open(EnviarCorreoTestigoComponent);
    modalRef.componentInstance.testigo = testigo;
  }
}
